<template>
    <b-container fluid>
        <b-row>
            <b-col cols="6" class="mt-3">
                <label for="input-created_start" class="mb-3"><strong>{{$translate('start_date')}}</strong></label>
                <b-form-input type="date" id="input-created_start" v-model="model.created_start"></b-form-input>
            </b-col>
            <b-col cols="6" class="mt-3">
                <label for="input-created_end" class="mb-3"><strong>{{$translate('end_date')}}</strong></label>
                <b-form-input type="date" id="input-created_end" v-model="model.created_end"></b-form-input>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="6" class="mt-3 dd">
                <label for="input-type" class="mb-3"><strong>{{ $translate('type') }}:</strong></label>
                <b-form-select id="input-type" class="form-control" v-model="model.order_type_id" :options="orderTypes"
                    value-field="id" text-field="name">
                </b-form-select>
            </b-col>
            <b-col cols="6" class="mt-3 dd">
                <label for="input-order_category" class="mb-3"><strong>{{$translate('service_category') }}</strong></label>
                <b-form-select id="input-order_category" class="form-control" v-model="model.service_category"
                    value-field="id" text-field="name" :options="categories"></b-form-select>

            </b-col>
        </b-row>
    </b-container>
</template>
<script>
export default {
    data() {
        return {
            model: {
                order_type_id: 0,
                service_category: 0,
                created_start: null,
                created_end: null,
            },
        }
    },
    props: ['value'],

    methods: {
        // Used for passing data from child component to parent
    },

    watch: {
        model: {
            handler: function (_model) {
                this.$emit('input', { ..._model })
            },
            deep: true,
        },
    },
    mounted() {
        // Store ordertypes in vuex store
        this.$store.dispatch('orderType/customerFetchAll')
        // Store order categories in vuex store
        this.$store.dispatch('requestCategory/fetchAll')
        this.model = { ...this.value }
    },
    computed: {
        orderTypes() {
            const orderTypes = this.$store.state.orderType.items
                .filter(x => !!x.is_customer_portal_visible)
                .map(x => ({
                    id: x.id,
                    name: x.customer_portal_name || x.name,
                }))
            console.log('orderTypes', orderTypes)
            return [{ name: this.$translate('any'), id: 0 }, ...orderTypes]
        },

        categories() {
            const categories = this.$store.state.requestCategory.categories
            console.log('Order Categories', categories)
            return [{ name: this.$translate('any'), id: 0 }, ...categories]
        },
    },
}
</script>